import { gql, useQuery } from '@apollo/client';
import { Button, ButtonProps, Flex } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { ECommunityAccessConfig } from '@/graphql-types/globalTypes';
import { logError } from '@/imports/logging/ClientLogger';

import { SeeMorePosts_CurrentUser_Tenant } from './graphql-types/SeeMorePosts_CurrentUser_Tenant';

const USER_QUERY = gql`
  query SeeMorePosts_CurrentUser_Tenant {
    currentUser {
      _id
      canAccessCommunity
    }
    tenant {
      result {
        _id
        communityAccessConfig
      }
    }
  }
`;

export const SeeMorePosts: React.FC<ButtonProps> = ({ ...buttonProps }) => {
  const { data, error } = useQuery<SeeMorePosts_CurrentUser_Tenant>(USER_QUERY);

  const isVisitingPublicCommunityWhileLoggedOut =
    data?.tenant.result?.communityAccessConfig ===
      ECommunityAccessConfig.PUBLIC && !data?.currentUser;

  const canAccessCommunity =
    data?.currentUser?.canAccessCommunity ||
    isVisitingPublicCommunityWhileLoggedOut;

  if (error) {
    logError(error);
  }

  if (!canAccessCommunity) {
    return null;
  }

  return (
    <Flex justify="center">
      <NextLink href="/community">
        <Button {...buttonProps}>See More Posts</Button>
      </NextLink>
    </Flex>
  );
};
